import { render, staticRenderFns } from "./weapons.vue?vue&type=template&id=8d97bcd8&scoped=true&"
import script from "./weapons.vue?vue&type=script&lang=js&"
export * from "./weapons.vue?vue&type=script&lang=js&"
import style0 from "./weapons.vue?vue&type=style&index=0&id=8d97bcd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d97bcd8",
  null
  
)

export default component.exports